import { CumulativeInvoice } from "../cumulativeInvoice.ts";
import { BaseSerializer } from "./baseSerializer.ts";



export class CumulativeInvoiceSerializer extends BaseSerializer {

    public deserialize( data: any ): any {

        const gp = new CumulativeInvoice();

        this._copyAttributes(gp, data);

        return gp;

    }

}
